module.exports = __webpack_public_path__ + "img/setting.26aa3016.svg";